import { Journey } from "../types";

export const groupByDate = (journeys: Journey[]) => {
  return journeys.reduce((acc, journey) => {
    const date = journey.departure;
    if (!acc[date]) {
      acc[date] = [];
    }
    acc[date].push(journey);
    return acc;
  }, {} as { [date: string]: typeof journeys });
};
